import { render, staticRenderFns } from "./EarnFromReferrals.vue?vue&type=template&id=689df675&"
import script from "./EarnFromReferrals.vue?vue&type=script&lang=js&"
export * from "./EarnFromReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports